<!--
 * @Author: Latte
 * @Date: 2022-01-26 16:13:48
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-28 14:24:42
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\mai\previewResource\productionInfo.vue
-->
<template>
  <div class="app-container">
    <div class="topbar">
      <div></div>
      <div>
        <el-button
          class="iconfont icon-xiaosuolvetu"
          :class="{ active: layoutMode === 'grid' }"
          size="small"
          title="网格模式"
          @click="layoutMode = 'grid'"
        ></el-button>
        <el-button
          class="iconfont icon-ic_mode_table"
          :class="{ active: layoutMode === 'list' }"
          size="small"
          title="列表模式"
          @click="layoutMode = 'list'"
        ></el-button>
      </div>
    </div>

    <!-- 网格模式 -->
    <div v-show="layoutMode === 'grid'">
      <el-row :gutter="20">
        <el-col :span="6" v-for="item in fileList" :key="item.name">
          <el-card
            style="margin-bottom: 15px; cursor: pointer"
            @click.native="goToDetail"
          >
            <el-image
              style="width: 100px; height: 100px"
              :src="item.imageUrl"
              fit="scale-down"
            ></el-image>
            <h2>
                <el-popover
                        placement="top-start"
                        trigger="hover"
                        :disabled="item.title.length <= 10">
                  <div>{{ item.title }}</div>
                  <span slot="reference" v-if="item.title.length <= 10">{{item.title}}</span>
                  <span slot="reference" v-if="item.title.length > 10">{{item.title.substr(0, 8) + ".."}}</span>
                </el-popover>
            </h2>
            <span >{{item.desc}}</span><br>
            <div>
              <div style="margin-top: 10px;font-size: 15px">{{item.createTime}}</div>
              <div style="margin-top: 10px;margin-bottom:-15px;margin-right: 10px" align="right">
                <i class="el-icon-view">
                  <span style="margin-left:5px;color:#778089">{{item.visits}}</span>
                </i>
                <i class="el-icon-download" style="margin-left:20px">
                  <span style="margin-left:5px;color:#778089">{{item.downloadTimes}}</span>
                </i>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <!-- 列表模式 -->
    <div v-show="layoutMode === 'list'">
      <el-table
        :data="fileList"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%; margin-bottom: 20px"
      >
        <el-table-column label="id" prop="id" align="center"></el-table-column>
        <el-table-column
          label="资料名称"
          prop="title"
          align="center"
        >
          <template slot-scope="scope">
            <el-popover
                    placement="top-start"
                    trigger="hover"
                    :disabled="scope.row.title.length <= 10">
              <div>{{ scope.row.title }}</div>
              <span slot="reference" v-if="scope.row.title.length <= 10">{{scope.row.title}}</span>
              <span slot="reference" v-if="scope.row.title.length > 10">{{scope.row.title.substr(0, 10) + "..."}}</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="资料类型"
          prop="type"
          align="center"
        ></el-table-column>
        <el-table-column
          label="文件后缀"
          prop="suffix"
          align="center"
        ></el-table-column>
        <el-table-column label="资料详情" align="center" width="350">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click.stop="goToDetail(scope.row.url)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

    </div>
    <!-- 分页 -->
    <el-pagination
            background
            layout="prev, pager, next"
            :total="totalCount"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="currentChange"
    />
  </div>
</template>

<script>
import {getFileListByUser} from "../../../api/system/CSDocument/file";
import iconmp4 from "/src/assets/images/icon-mp4.png";
import iconjpg from "/src/assets/images/icon-jpg.jpg";
import iconpng from "/src/assets/images/icon-png.jpg";
import iconmp3 from "/src/assets/images/icon-mp3.jpg";
import iconpdf from "/src/assets/images/icon-pdf.jpg";

function formatDate(date) {
  var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}

export default {
  name: "",

  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalCount: 1,
      layoutMode: "grid", // 布局方式，默认网格
      fileList: [],
    };
  },

  created() {
    this.getList();
  },
  methods: {
    /**
     * 分页查询
     * @param {number} currentPage 当前页码
     */
    getList(){
      let params={
        pageNumber:this.currentPage,
        pageSize:this.pageSize,
        sortOrder:"desc"
      };
      getFileListByUser(params).then((res)=>{
        console.log(res);
        this.totalCount=res.Total;
        if(res.Rows.length!==0){
          var tempList=res.Rows;
          for(var temp of tempList){
            var imageUrl=""
            if(temp.FileSuffix!==""){
              if(temp.FileSuffix.indexOf("mp3") >= 0){imageUrl=iconmp3;}
              else if(temp.FileSuffix.indexOf("mp4") >= 0){imageUrl=iconmp4;}
              else if(temp.FileSuffix.indexOf("jpg") >= 0){imageUrl=iconjpg;}
              else if(temp.FileSuffix.indexOf("png") >= 0){imageUrl=iconpng;}
              else if(temp.FileSuffix.indexOf("pdf") >= 0){imageUrl=iconpdf;}
            }
            this.fileList.push({
              id:temp.CsFileID,
              title:temp.FileShowName,
              suffix:temp.FileSuffix,
              visits:temp.ViewTimes,
              downloadTimes:temp.DownloadTimes,
              url:temp.DownUrl,
              imageUrl:imageUrl,
              createTime:formatDate(temp.CreateTime),
              desc:temp.FileDesc,
              type: temp.TypeList.length>0? temp.TypeList[0].TypeName:"未知",
            });
          }
        }

      });

    },

    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.fileList=[];
      this.getList();
    },

    goToDetail(url) {
      // this.$router.push({ name: "productionDetail" });
      if(url!==""){
        window.open(this.config.RESOURCES+url);
      }
    },
  },
};
</script> 


<style scoped>
.active {
  color: #409eff;
}
</style>
